import React from 'react';

interface MultiSelectProps {
    value: string;
    options: string[];
    onChange: (value: string) => void;
    placeholder?: string;
    from: string
}

const MultiSelect: React.FC<MultiSelectProps> = ({
    value,
    options,
    onChange,
    placeholder = '+ Add',
    from
}) => {
    const selectedItems = (value || '').split(',').filter(item => item.trim());
    const selectedLower = selectedItems.map((item) => item.trim().toLowerCase());
    const availableOptions = options.filter(
        (option) => !selectedLower.includes(option.trim().toLowerCase()),
    );

    const handleRemoveItem = (itemToRemove: string) => {
        const removeLower = itemToRemove.trim().toLowerCase();
        const newItems = selectedItems.filter(
            (item) => item.trim().toLowerCase() !== removeLower,
        );
        onChange(newItems.join(','));
    };

    const handleAddItem = (value: string) => {
        const updatedCategories = [...selectedItems, value];
        onChange(updatedCategories.join(','));
    };

    return (
        <div className="custom-multiselect">
            <div className="selected-items">
                {selectedItems.map((item, index) => (
                    <div key={index} className="selected-item">
                        <span className="selected-item-label">{item.trim()}</span>
                        <button
                            className="remove-btn"
                            onClick={() => handleRemoveItem(item)}
                        >
                            ×
                        </button>
                    </div>
                ))}
                <div
                    className="dropdown-container"
                    onBlur={(e) => {
                        if (!e.currentTarget.contains(e.relatedTarget)) {
                            const dropdown = e.currentTarget.querySelector('.dropdown-list');
                            if (dropdown) {
                                dropdown.classList.remove('show');
                            }
                        }
                    }}
                >
                    <button
                        className="add-btn"
                        onClick={(e) => {
                            e.currentTarget.nextElementSibling?.classList.toggle('show');
                        }}
                    >
                        {placeholder}
                    </button>
                    <div
                        className="dropdown-list"
                        tabIndex={-1}
                    >
                        {availableOptions.map((option, index) => (
                            <div
                                key={index}
                                className="dropdown-item"
                                onClick={(e) => {
                                    handleAddItem(option);
                                    const dropdown = e.currentTarget.closest('.dropdown-list');
                                    if (dropdown) {
                                        dropdown.classList.remove('show');
                                    }
                                }}
                            >
                                {option}
                            </div>
                        ))}
                        {availableOptions.length === 0 && (
                            <div className="dropdown-item no-options">
                                No options available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiSelect;
